"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var classnames_1 = __importDefault(require("classnames"));
var GeneralSettings_1 = require("../../../../constants/GeneralSettings");
var RequiredIcon_1 = __importDefault(require("../../../Icons/RequiredIcon"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var MenuItems = function (_a) {
    var setActiveItem = _a.setActiveItem, activeItem = _a.activeItem;
    var t = react_i18next_1.useTranslation('common').t;
    return (react_1.default.createElement("div", { className: classnames_1.default('ui secondary pointing menu', styles_module_scss_1.default.menu_items) },
        react_1.default.createElement("a", { className: classnames_1.default('item', activeItem === GeneralSettings_1.BUILDING_MEDIA_TYPES.BUILDING_PICTURES &&
                styles_module_scss_1.default['active_item']), onClick: function () {
                return setActiveItem(GeneralSettings_1.BUILDING_MEDIA_TYPES.BUILDING_PICTURES);
            } },
            t('fields.section4.file_upload.pictures'),
            react_1.default.createElement("span", { className: styles_module_scss_1.default.required_field },
                react_1.default.createElement(RequiredIcon_1.default, null))),
        react_1.default.createElement("a", { className: classnames_1.default('item', activeItem === GeneralSettings_1.BUILDING_MEDIA_TYPES.BUILDING_VIDEOS &&
                styles_module_scss_1.default['active_item']), onClick: function () {
                return setActiveItem(GeneralSettings_1.BUILDING_MEDIA_TYPES.BUILDING_VIDEOS);
            } }, t('fields.section4.file_upload.videos')),
        react_1.default.createElement("a", { className: classnames_1.default('item', activeItem === GeneralSettings_1.BUILDING_MEDIA_TYPES.BUILDING_PERMIT &&
                styles_module_scss_1.default['active_item']), onClick: function () {
                return setActiveItem(GeneralSettings_1.BUILDING_MEDIA_TYPES.BUILDING_PERMIT);
            } }, t('fields.section4.file_upload.building_permit')),
        react_1.default.createElement("a", { className: classnames_1.default('item', activeItem === GeneralSettings_1.BUILDING_MEDIA_TYPES.BUILDING_GENERAL_PLAN &&
                styles_module_scss_1.default['active_item']), onClick: function () {
                return setActiveItem(GeneralSettings_1.BUILDING_MEDIA_TYPES.BUILDING_GENERAL_PLAN);
            } }, t('fields.section4.file_upload.general_plan'))));
};
exports.default = MenuItems;
